import { EconomicsProvider } from '@/contexts/EconomicsContext'
import { StakingProvider } from '@/contexts/StakingContext'

import { BodyStack } from '../../styled/components'
import HelpDrawer from '../HelpDrawer/HelpDrawer'
import GovernanceCarousel from './GovernanceCarousel'
import Staking from './Staking/Staking'
import Supply from './Supply'

const Component: React.FC = () => (
  <>
    <EconomicsProvider>
      <StakingProvider>
        <BodyStack style={{ gap: '60px' }}>
          <Staking />
          <Supply />
          <GovernanceCarousel />
        </BodyStack>
        <HelpDrawer id="staking" />
      </StakingProvider>
    </EconomicsProvider>
  </>
)

Component.displayName = 'StakingPage'

// eslint-disable-next-line import/prefer-default-export
export { Component }
